import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)

var store = new Vuex.Store({
    state: {
        sidebar: '',
        sidebarsub: '',
    },
    mutations: {
        ACTIVE_SIDEBAR(state, val) {
            state.sidebar = val
        },
        ACTIVE_SIDEBARSUB(state, val) {
            state.sidebarsub = val
        }
    },
    getters: {
        sidebar: state => state.sidebar,
        sidebarsub: state => state.sidebarsub,
    }
})

export default store